import OrderDetails from './OrderDetails'
import Payment from './Payment'

export { OrderDetails, Payment }



// WEBPACK FOOTER //
// ./src/features/OrderDetails/containers/index.js